<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<!-- 动态按钮生成 -->
		<div class="content_edit">
			<pre-btn-Excel @button-event="select_method" :pre_control="control" />
			<div class="content_btn">
				<div class="content_btn_item">
					<slot name="pre_base_button"></slot>
					<button @click="look_note">备注说明</button>
					<button class="pre_btn_ok" v-show="show_step_btn" @click="fun_show_step">审核流程</button>
				</div>
			</div>
		</div>
		<!-- 动态查询区生成 -->
		<div class="content_edit">
			<div class="content_edit_item" v-for="(item,index) in parm_sel" :key="index">
				<component v-if="refresh_sel" :is="NextTickName(item.type)" :inData="checkJson(item)"
					@com-event="refresh_view_sel" ref="selzj"></component>
			</div>
			<div class="content_edit_item" v-show="file_show">
				<label>文件:</label>{{file_name}}&nbsp;&nbsp;{{file_up}}
			</div>
		</div>


		<!-- 通用导入excel -->
		<per-excelup ref="excelup" @excelup-event="refresh_data" :pre_th="parm" :api_url="sel_action"
			:api_action="upd_action" :api_method="edit_flag" :api_check="check_key" />

		<!-- 主界面内容显示 start -->
		<pre-table ref="file_table" @tab-event="refresh_data" :api_url="load_url" :pre_post="load_json"
			:pre_post_upd="upd_json">
			<!-- 设定标题  -->
			<template slot="tab_title">
				<tr class="tab_header_new" :class="[isTwo=='1'?TwoNone:'']">
					<td>ID</td>
					<td v-for="(t,index) in parm_th" :key="index">{{t.name}}</td>
				</tr>
			</template>
			<template slot="tab_tr" slot-scope="user">
				<tr :id="'m_'+user.item[1].val" :class="[isTwo=='1'?TwoNone:'']" @click="sel_row(user.item,'all')"
					@dblclick="edit_data">
					<!-- <a href="#"> -->
					<td v-for="(d,index) in user.item" :key="index" v-on:mousemove="show_detaildata($event, d.val, '1')"
						v-on:mouseout="noshow_detaildata">
						<!-- <div v-if="d.key=='imageList'">
              <ul>
                <li v-for="(t,id) in d.val" :index="id">
                  <button @click="fun_show_detail(t)">{{t.f_name}}</button>
                </li>
              </ul>
            </div>
            {{d.val}} -->

						<div v-if="d.key=='img_url'">
							<el-image style="width: 20px; height: 20px" :src="check_url(d.val)"
								:preview-src-list="[check_url(d.val)]">
							</el-image>
						</div>
						<div v-else-if="d.key=='f_web_url'">
							<a :href="d.val" target="_blank">外链</a>
						</div>
						<div v-else>{{d.val}}</div>
					</td>
					<!-- </a> -->
				</tr>
			</template>
			<!-- 构建新增模板 -->
			<template slot="tab_addorupdate">

			</template>
		</pre-table>
		<!-- 主界面内容显示 end -->

		<!-- 通用导出excel -->
		<per-exceldown v-show="show_excel" @exceldown-event="build_exceldata" :title="'下载数据'"
			v-bind:pre_postjson="postjson1" :clicktype="'down1'">
			<template slot="tab_excelup_title">
				<tr>
					<th>ID</th>
					<th v-for="(t,index) in parm_th" :key="index">{{t.name}}</th>
				</tr>
			</template>
			<template slot="tab_excelup_tr" slot-scope="user">
				<tr>
					<td style="mso-number-format:'\@';" v-for="(d,index) in user.item" :key="index">
						<template v-if="d.key=='img_url'">
							<!-- <div style="display:inline">
								<img style="width: 20px; height: 20px;max-width:60px;max-height: 60px;"
									:src="check_url(d.val)">
							</div> -->
							<!-- 如果是通过style或者class加的样式，宽高是不生效的
								一定要用img的原生属性 -->
							<img width="25" height="25" :src="check_url(d.val)">
						</template>

						<template v-else>{{d.val}}</template>
					</td>
				</tr>
			</template>
		</per-exceldown>

		<!-- 弹窗编辑 start -->
		<div v-show="show_tan" class="pre_tan">
			<span class="pre_tan_bg"></span>
			<!-- <span class="pre_tan_bg" @click="closeshow"></span> -->
			<div class="pre_tan_conten">
				<span class="pre_tan_close">
					<img src="../../assets/image/shan1.png" @click="closeshow" />
				</span>
				<div class="pre_upload">
					<div class="pre_leve_one">
						<h3 class="cen">{{title}}</h3>
						<!-- 操作按钮生成 -->
						<div class="content_edit">
							<div class="content_edit_item">
								<pre-button @button-event="select_method" :pre_control="control" />
								<div class="content_btn">
									<div class="content_btn_item">
										<button class="pre_btn_ok" v-show="show_step_btn"
											@click="fun_show_step">审核流程</button>
										&nbsp;&nbsp;<slot name="pre_tan_button"></slot>
									</div>
								</div>
							</div>
							<div class="content_edit_item" v-show="sheet_flag!=''?true:false">
								<h3 class="red">
									{{sheet_flag}}
								</h3>
							</div>
						</div>
						<!-- 这里放主单据编辑内容-->
						<div class="content_edit">
							<div class="content_edit_item tab-row" v-for="(r,d) in max_row" :key="d">
								<div class="content_edit_item" v-if="item.x == r.row" v-for="(item,index) in parm"
									:key="index">
									<!-- {{handleImportView(item)}} -->

									<component ref="editfatherzj" :is="NextTickName(item.type)"
										:inData="checkJson(item)" @com-event="refresh_view_edit">
									</component>
								</div>
							</div>

							<div class="content_edit" v-show="file_show && show_FileMain">
								<div class="content_edit_item">
									<label>文件:</label><span>{{file_name}}&nbsp;&nbsp;{{file_up}}</span>
								</div>
							</div>

						</div>

					</div>

					<div v-show="show_d" class="pre_leve_two">
						<!-- 这里放明细单据内容 -->
						<h5 class="cen pretop">{{title}}明细</h5>
						<!-- 明细部分编辑区 -->
						<div v-show="show_d_edit" class="content_edit">
							<div class="content_btn_row">
								<div class="content_btn">
									<div class="content_btn_item">
										<button class="pre_btn_ok" @click="fun_d_load()">
											查询
										</button>
										<button class="pre_btn_ok" @click="d_data_clear()">
											清空
										</button>
										<button class="pre_btn_ok" @click="fun_d_save('_add')">
											增加
										</button>
										<button class="pre_btn_ok" @click="fun_d_save('_upd')">
											修改
										</button>
										<button v-show="d_btn_more" class="pre_btn_ok" @click="fun_d_save('_sub')">
											提交
										</button>
										<button v-show="d_btn_more" class="pre_btn_ok" @click="fun_d_save('_bad')">
											作废
										</button>
									</div>
								</div>
							</div>

							<div class="content_edit_item" v-for="(item,index) in d_parm" :key="index">
								<component :is="NextTickName(item.type)" :inData="checkJson(item)"
									@com-event="refresh_view_edit_d">
								</component>
							</div>

							<div class="content_edit_item" v-show="file_show && show_FileChildren">
								<label>文件:</label>{{file_name}}&nbsp;&nbsp;{{file_up}}
							</div>
						</div>
						<!-- 明细部分展示区 -->
						<div id="pre_tab" class="pre_tab">
							<table class="pre_table_detail_new" border="1" cellpadding="2" cellspacing="1">
								<tr class="tab_header_new" :class="[isTwoDetail=='1'?TwoNone:'']">
									<td v-for="(t,index) in d_name" :key="index">{{t.name}}</td>
									<td>操作</td>
								</tr>
								<tr :id="'d_'+data_tr[0].val" :class="[isTwoDetail=='1'?TwoNone:'']"
									v-for="data_tr in d_detail" @click="fun_d_upd(data_tr)">
									<!-- <a href="#"> -->
									<td v-for="(d,index) in data_tr" :key="index"
										v-on:mousemove="show_detaildata($event, d.val, '1')"
										v-on:mouseout="noshow_detaildata">
										<a href="#">{{d.val}}</a>
									</td>
									<!-- </a> -->
									<td>
										<span v-show="show_d_edit" @click="fun_d_edit('_upd',data_tr)">
											<i class="iconfont icon-bianji"></i>修改
										</span>
										<span v-show="show_d_edit && d_btn_del " @click="fun_d_del('_del',data_tr)">
											<i class="iconfont icon-shanchu"></i>删除
										</span>
									</td>
								</tr>
							</table>
						</div>

					</div>

					<!-- 弹出向导层 end-->
				</div>
			</div>

		</div>

		<!-- 弹窗编辑 end -->

		<pre-step :pre_show_tan="show_step" :pre_data="show_stepdata" />

		<!-- 隐藏聚焦点 -->
		<div><input id="pre_displaynone" style="display:none;" /></div>

		<!-- 明细数据提示 -->
		<div id="pre_detail_data" style="display:none;">
			<p v-for="(item, index) in detail_data" :key="index">
				{{ item.name }}={{ item.amount }}
			</p>
		</div>
		<div id="pre_msg_data" style="display:none;"></div>
		
		<prefilelist ref="myfilelist" @filelist-event="refresh_data" />

	</div>
</template>

<script>
	import api from '@/utils/type.js';
	import {
		Select_PageLength,
		Select_PageLengthMore,
		Method_Common,
		Method_CommonLong,
		Method_CommonLongLong,
		Method_EasySelect,
		Method_TableAll
	} from '@/utils/loadhttpdata.js';

	import {
		dateFormatbyChina,
		dateFormatToChina,
		Word_Right_Delete,
		JsonStr
	} from '@/utils/method.js';

	import {
		BackSpecial
	} from "@/utils/localstore.js";


	//查询方式不变的老 模版:返回结果还是字符串:主要变化、编辑区域组件化和增加分页

	//以此为模版同步，所有 主单据+明细项目

	// 测试中发现，在select中完成配置数据查询,在多级联动是不能相应！！！！
	// 所以，不在子组件中完成加载

	export default {
		name: "old_view_v2",
		components: {
			"pre-button": () => import("../per_old/pre_btn_control_tan_newfile.vue"),
			"pre-btn-Excel": () => import("../per_old/pre_btn_control_newfile.vue"),
			"pre-table": () => import("./old_view_table.vue"),
			'per-exceldown': () => import("../per_old/pre_excel_down.vue"),
			'per-excelup': () => import("../per_old/pre_excel_up_new.vue"),
			"pre-step": () => import("../per_old/pre_base_tan_step.vue")
		},
		data() {
			return {
				element_loading: false,
				control: '',
				load_url: '',
				load_json: '',
				upd_json: '',
				nowpage: '1',
				page_length: 20, //add 2022-01-25 默认分页长度
				title: '未设置标题',
				sel_action: '',
				upd_action: '',
				edit_flag: '', //add 2022-02-15 编辑类型标识
				check_key: '', //add 2022-02-15 结构匹配标识
				row_id: '',
				sys_date: '',
				// 审核标记
				sheet_flag: '',
				sheet_no: '',
				show_btn: true,

				sel_action_flag: "", //更多查询参数20
				refresh_sel: true, //强制刷新组件

				parm_sel: [], //查询结构
				parm: [], //参数结构
				parm_th: [], //标题
				kw1: '',
				kw2: '',
				kw3: '',
				kw4: '',
				kw5: '',
				kw6: '',
				kw7: '',
				kw8: '',
				kw9: '',

				// excel
				show_excel: false,
				postjson1: {},
				// radio
				radio: '1',
				d_radio: '1',
				// 弹窗编辑
				show_tan: false,

				// 明细部分参数
				show_d: false,
				show_d_edit: true,

				d_btn_more: false,
				d_btn_del: true,
				d_load_url: '',
				d_sel_action: '',
				d_upd_action: '',
				d_row_id: '',
				d_sys_date: '',
				d_parm: [], //明细参数构造
				d_name: [], //明细标题
				d_detail: [], //明细数据

				// 备注
				detail_data: '',
				//文件
				// 查询判断
				sel_from: 'm',
				file_list_main: [],
				/*add 2022-02-20 图片存储*/
				file_show: false,
				file_name: "",
				file_data: "",
				file_up: "",
				file_url: "",
				file_src: "",
				file_size: "0",
				file_action: '',
				blockSize: '',
				file_backdata: '',
				p1: '',
				p2: '',
				p3: '',
				// swich 开关
				show_in: true,
				show_out: false,

				// 自定义组件 流程
				show_step: '0',
				show_stepdata: '',
				pass_step: "0",
				show_step_btn: false,

				// checkbox 组件
				isIndeterminate: true,
				show_note: false,

				max_row: [],
				// 主单据附件判断
				isFileMain: 0,
				show_FileMain: false,
				show_FileChildren: true,

				// 定义默认样式
				isTwo: '0',
				isTwoDetail: '0',
				TwoNone: 'last-two-none',

				isFatherSel: '' ,//通过查询条件查询父窗口
				
				// 组件按钮权限获取
				filelist_control: {}

			};
		},
		props: {
			pre_data: {
				type: String,
				default: ''
			}
		},
		watch: {
			pre_data(val) {
				if (val.length > 20) {
					// console.log(val);
					this.tab_data = val;
					if (typeof(this.tab_data) !== 'undefined' && this.tab_data != '') {
						let that = this;
						this.$nextTick(function() {
							//console.log('加载配置完成', JSON.parse(val));
							this.load_data();
						});
					}
				}
			},
			d_sel_action(val) {
				if (typeof(this.d_upd_action) != 'undefined' && this.d_upd_action != '') {
					this.show_d = true;
				} else {
					this.show_d = false;
				}
			},
			sheet_flag(val) {
				if (val == '已提交') {
					// this.show_btn = false;
					this.show_d_edit = false;
				} else {
					// this.show_btn = true;
					this.show_d_edit = true;
				}
			},
			show_in(val) {
				console.log('==' + val);
				if (val) {
					this.show_out = false;
				} else {
					this.show_out = true;
				}
			},
			pass_step(val) {
				if (val == '1') {
					this.show_step_btn = true;
				} else {
					this.show_step_btn = false;
				}
			},
			isFileMain(val) {
				if (val == '1') {
					this.show_FileMain = true;
					this.show_FileChildren = false;
				} else {
					this.show_FileMain = false;
					this.show_FileChildren = true;
				}
			}

		},
		mounted: function() {
			// if (this.pre_data != '') {
			//   console.log('加载====');
			//   let that = this;
			//   this.$nextTick(function() {
			//     this.load_data();
			//   });
			// }
			let that = this;
			setTimeout(() => {

				this.load_data();
			}, 0)
		},
		methods: {
			fun_file_list: function(sheet_no, id, flag, f_url, f_src, tf) {
				// console.log('当前附件集组件权限', this.filelist_control);
				if (typeof(this.filelist_control.isok) === 'undefined') {
					// console.log('正在校验附件集组件操作权限,请等待');
					this.$message({
						message: '正在校验附件集组件操作权限,请等待',
						type: 'warning'
					});
					return;
				}
				if (this.filelist_control.isok == '0') {
					// console.log('您没有附件集组件的操作权限!');
					this.$message({
						message: this.filelist_control.msg,
						type: 'warning'
					});
					return;
				}
			
				let p = {};
				p.title = this.title;
				p.file_action = this.file_action;
				p.p1 = this.p1;
				p.p2 = this.p2;
				p.p3 = this.p3;
			
				p.file_src = f_src;
				p.file_url = f_url;
			
				p.sheet_no = sheet_no;
				p.row_id = id;
				p.sheet_flag = flag;
				p.filelist = tf;
			
				p.file_up = this.filelist_control.fileup;
				p.file_look = this.filelist_control.filelook;
				p.file_del = this.filelist_control.filedel;
			
				p.sel_from = this.sel_from;
			
				this.$refs['myfilelist'].load_data(p);
			},			
			NextTickName: function(key) {
				// console.log('key=' + key);
				
				return 'pre' + key;
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			check_url: function(url) {
				let t = BackSpecial(url);
				// console.log(t);
				return t;
			},
			refresh_view_sel: async function(d) {
				// console.log('查询回传=', d);
				for (let i = 0; i < this.parm_sel.length; i++) {
					if (this.parm_sel[i].key == d.key) {
						if (this.parm_sel[i].type == 'selectnew' || this.parm_sel[i].type == 'radio') {
							this.parm_sel[i].val = d.val;
							this.parm_sel[i].sel_name = d.sel_name;

							let str = '';
							str = String(d.sel_more);
							// console.log('标识位=' + str.indexOf('_to'));
							// 
							if (typeof(str) !== 'undefined' && str.indexOf('_to') > 0) {
								let sel_key = str.substring(0, 1);
								// console.log('联动查询关键字=' + sel_key);


								for (let j = 0; j < this.parm_sel.length; j++) {
									if (this.parm_sel[j].sel_more == sel_key && typeof(this.parm_sel[j].sel_action) !==
										'undefined' &&
										this.parm_sel[j].sel_action != '') {
										this.parm_sel[j].list = [];
										this.parm_sel[j].val = '';
										this.parm_sel[j].sel_name = '';

										let res = await this.loadClass(this.parm_sel[j].sel_action, d.val);
										// console.log('查询返回', res);
										if (res.status == '1') {
											this.parm_sel[j].list = res.data;
										}
										// console.log(this.parm_sel);
										// console.log(this);
										// 强制刷新子组件数据
										this.$refs.selzj[j].refresh_select(JSON.stringify(this.parm_sel[j]));
										// 全部刷新了，不行
										// this.refresh_sel = false;
										// this.$nextTick(() => {
										//   this.refresh_sel = true;
										// })



									}
								}
							}

							break;
						} else {
							this.parm_sel[i].val = d.val;
							break;
						}

						break;
					}
				}

			},
			refresh_view_edit: async function(d, type) {
				// console.log(d);
				// console.log('编辑更新前', this.parm);

				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].key == d.key) {

						if (this.parm[i].type == 'selectnew' || this.parm[i].type == 'select' || this.parm[i].type ==
							'radio') {
							this.parm[i].val = d.val;
							this.parm[i].sel_name = d.sel_name;

							if (String(d.sel_more).indexOf('_to') > 0) {
								let sel_key = String(d.sel_more).substring(0, 1);
								// console.log('编辑联动查询关键字=' + sel_key);

								for (let j = 0; j < this.parm.length; j++) {
									if (this.parm[j].sel_more == sel_key && typeof(this.parm[j].sel_action) !==
										'undefined' && this
										.parm[j].sel_action != '') {

										this.parm[j].list = [];
										this.parm[j].val = '';
										this.parm[j].sel_name = '';

										let res = await this.loadClass(this.parm[j].sel_action, d.val);
										if (res.status == '1') {
											this.parm[j].list = res.data;
										}
										// console.log(this.parm_sel);
										// console.log(this);
										// 强制刷新子组件数据
										this.$refs.editfatherzj[j].refresh_select(JSON.stringify(this.parm[j]));
									}
								}
							}

							break;
						} else {
							this.parm[i].val = d.val;
							break;
						}

						break;
					}
				}
				// console.log('编辑更新后', this.parm);

				if (type == 'save') {
					this.fun_upd('_add');
				}
			},
			refresh_view_edit_d: async function(d, type) {
				// console.log(d);
				for (let i = 0; i < this.d_parm.length; i++) {
					if (this.d_parm[i].key == d.key) {
						if (this.d_parm[i].type == 'selectnew' || this.d_parm[i].type == 'select' || this.d_parm[i]
							.type == 'radio') {
							this.d_parm[i].val = d.val;
							this.d_parm[i].sel_name = d.sel_name;

							if (String(d.sel_more).indexOf('_to') > 0) {
								let sel_key = String(d.sel_more).substring(0, 1);
								console.log('编辑联动查询关键字=' + sel_key);

								for (let j = 0; j < this.d_parm.length; j++) {
									if (this.d_parm[j].sel_more == sel_key && typeof(this.d_parm[j].sel_action) !==
										'undefined' && this
										.d_parm[j].sel_action != '') {

										this.d_parm[j].list = [];
										this.d_parm[j].val = '';
										this.d_parm[j].sel_name = '';

										let res = await this.loadClass(this.d_parm[j].sel_action, d.val);
										if (res.status == '1') {
											this.d_parm[j].list = res.data;
										}
										// console.log(this.parm_sel);
										// console.log(this);
										// 强制刷新子组件数据
										this.$refs.editfatherzj[j].refresh_select(JSON.stringify(this.d_parm[j]));
									}
								}
							}

							break;
						} else if (this.d_parm[i].type == 'switch') {

							// 不能这样切换,因为 key不是唯一哦！！！！
							// 针对 切换模式的 附加参数的 设定
							for (let j = 0; j < this.d_parm.length; j++) {
								if (this.d_parm[j].key == 'io') {
									this.d_parm[j].val = d.io;
									break;
								}
							}
							this.d_parm[i].io = d.io;
							this.d_parm[i].val = d.val;
						} else {
							this.d_parm[i].val = d.val;
							break;
						}
						break;
					}
				}
				// console.log()

				if (type == 'save') {
					this.fun_d_save('_add');
				}
			},
			loadClass: function(action, p1, p2, p3) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2, p3)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res.data);
						resolve(res.data)
					});

				});
			},
			GetRandom() {
				return (Math.random() + '').substring(0, 8);
			},
			CheckRN(str) {
				let t = '';
				t = str;
				let reg = new RegExp('\r\n', 'g');
				t = t.replace(reg, '<br/>')
				return t;
			},
			fun_show_step: function() {
				console.log('sheet_no=' + this.sheet_no);
				if (typeof(this.sheet_no) == "undefined" || this.sheet_no == '') {
					this.$message({
						message: '请选择要操作的单据信息!',
						type: 'warning'
					});
					return
				}

				this.show_stepdata = '';
				this.show_stepdata = JSON.stringify({
					"title": this.title + '流程',
					"sheet_no": this.sheet_no,
					"sel_action": 'exp_step'
				});
				this.show_step = (Math.random() + '').substring(0, 8);

			},
			show_edit: function() {
				console.log('弹窗。。。。。');
				if (this.show_tan) {
					var Hg = $(document).height();
					// 设置背景高度
					$(".pre_tan_bg").height(Hg);
					// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
					$(".pre_tan_bg").fadeIn("3000");
					$(".pre_tan_conten").fadeIn("3000");

				} else {
					this.closeshow();
				}
			},
			closeshow: function() {
				$(".pre_tan_bg").fadeOut("3000");
				$(".pre_tan_conten").fadeOut("3000");
				this.show_tan = false;

				// 关闭窗口 应该更新编辑信息？=》如果发生编辑 =》才应该进行更新
				// 保证 编辑后清空 全部查询
				// for (let i = 0; i < this.parm_sel.length; i++) {
				//   this.parm_sel[i].val = '';
				// }

				this.load_db_data();
				// this.$emit('base2-event', 'father');
			},
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			load_data: async function() {
				// console.log(this.pre_data);
				// 初始化最大行数
				this.max_row = [];
				// for (let i = 1; i < 10; i++) {
				// 	let o = {};
				// 	o.row = i;
				// 	this.max_row.push(o);
				// }

				// 清理缓存
				this.row_id = '';
				this.sel_action = '';
				this.upd_action = '';
				this.edit_flag = '';
				this.check_key = '';


				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_size = '0';
				this.file_url = '';
				this.file_src = '';
				this.file_up = '';

				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'select') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
						this.parm[j].sel_val = {};
					} else {
						this.parm[j].val = '';
					}
				}

				this.d_row_id = '';
				this.d_sys_date = ''; //备份点击项目

				for (let j = 0; j < this.d_parm.length; j++) {
					if (this.d_parm[j].type != 'select') {
						this.d_parm[j].val = '';
					} else {
						this.d_parm[j].val = '';
						this.d_parm[j].sel_name = '';
						this.d_parm[j].sel_val = {};
					}
				}


				let r = JSON.parse(this.pre_data);
				// console.log(r);

				this.title = r.title;
				this.control = r.control;
				this.pass_step = r.step; //判断是否有业务流程
				this.isFileMain = r.isFileMain; //附件保存在主单据 | 还是明细

				this.sel_action_flag = r.sel_action_flag; //判断是否需要更多的查询参数
				// console.log('pass_step=' + this.pass_step);

				this.sel_action = r.sel_action;
				this.upd_action = r.upd_action;
				this.edit_flag = r.upd_action.substring(0, 5);
				this.check_key = r.check_key;
				// console.log('编辑标识=' + this.edit_flag);
				this.isFatherSel = r.isFatherSel; //通过查询条件刷新父窗口

				this.file_action = r.file_action;
				this.p1 = r.p1;
				this.p2 = r.p2;
				this.p3 = r.p3;

				this.parm_sel = r.parm_sel;
				this.parm = r.parm;
				this.parm_th = r.parm_th;

				for (let i = 1; i <= this.parm.length; i++) {
					let o = {};
					o.row = i;
					this.max_row.push(o);
				}



				/*初始化 select 数据 start*/

				for (let i = 0; i < this.parm_sel.length; i++) {
					if (this.parm_sel[i].type == 'selectnew') {
						let t = [];
						let t_sel_action = '';
						t_sel_action = this.parm_sel[i].sel_action;
						if (typeof(t_sel_action) !== 'undefined' && t_sel_action !== '') {
							//add 可以先抓取本地缓存再判断是否需要通过后台来 取数据

							let res = await this.loadClass(t_sel_action);
							if (res.status = '1') {
								t = res.data;
								this.parm_sel[i].list = t;
							}
							// console.log(res);

						}

					}
				}
				// console.log(this.parm_sel);


				for (let i = 0; i < this.parm.length; i++) {
					switch (this.parm[i].type) {
						case 'selectnew':
							let t = [];
							let t_sel_action = '';
							t_sel_action = this.parm[i].sel_action;
							if (typeof(t_sel_action) !== 'undefined' && t_sel_action != '') {
								let res = await this.loadClass(t_sel_action);
								if (res.status == '1') {
									t = res.data;
									this.parm[i].list = t;
								}
								// console.log(res);

							}
							break;
						case 'switch':
							let t_in_action = '',
								t_out_action = '';
							t_in_action = this.parm[i].action_in;
							t_out_action = this.parm[i].action_out;
							if (typeof(t_in_action) !== 'undefined' && t_in_action != '') {
								let res_in = await this.loadClass(t_in_action);
								// console.log('收入', res_in);
								if (res_in.status == '1') {
									this.parm[i].list_in = res_in.data;
								} else {
									this.parm[i].list_in = [];
								}
							}

							if (typeof(t_out_action) !== 'undefined' && t_out_action != '') {
								let res_out = await this.loadClass(t_out_action);
								// console.log('支出', res_out)
								if (res_out.status == '1') {
									this.parm[i].list_out = res_out.data;
								} else {
									this.parm[i].list_out = [];
								}
							}

							break;
					}

				}

				this.detail_part = r.detail_part;

				if (this.detail_part == '1') {
					this.d_sel_action = r.d_sel_action;
					this.d_upd_action = r.d_upd_action;
					this.d_parm = r.d_parm;
					this.d_name = r.d_name;
					this.d_detail = [];

					if (r.d_btn_more == '1') {
						this.d_btn_more = true;
					}

					if (r.d_btn_del == '0') {
						this.d_btn_del = false;
					}
					console.log('明细结构', this.d_parm);

					for (let i = 0; i < this.d_parm.length; i++) {
						switch (this.d_parm[i].type) {
							case 'selectnew':
								let t = [];
								let t_sel_action = '';
								t_sel_action = this.d_parm[i].sel_action;
								if (typeof(t_sel_action) !== 'undefined' && t_sel_action != '') {
									let res = await this.loadClass(t_sel_action);
									if (res.status != '1') {
										this.$message({
											type: 'info',
											message: res.msg
										});
										this.d_parm[i].list = [];
									} else {
										t = res.data;
										this.d_parm[i].list = t;
									}

								}
								break;
							case 'switch':
								let t_in_action = '',
									t_out_action = '';
								t_in_action = this.d_parm[i].action_in;
								t_out_action = this.d_parm[i].action_out;
								if (typeof(t_in_action) !== 'undefined' && t_in_action != '') {
									let res_in = await this.loadClass(t_in_action);
									// console.log('收入', res_in);
									if (res_in.status == '1') {
										this.d_parm[i].list_in = res_in.data;
									} else {
										this.d_parm[i].list_in = [];
									}
								}

								if (typeof(t_out_action) !== 'undefined' && t_out_action != '') {
									let res_out = await this.loadClass(t_out_action);
									// console.log('支出', res_out)
									if (res_out.status == '1') {
										this.d_parm[i].list_out = res_out.data;
									} else {
										this.d_parm[i].list_out = [];
									}
								}

								break;
						}

					}

				}

				if (typeof(r.isTwo) != "undefined" && r.isTwo != '') {
					this.isTwo = r.isTwo;
				}

				if (typeof(r.isTwoDetail) != "undefined" && r.isTwoDetail != '') {
					this.isTwoDetail = r.isTwoDetail;
				}

				this.load_db_data();
				this.load_power_filelist();
			},
			load_power_filelist: function() {
				let r = (Math.random() + '').substring(0, 8);
				this.$post(
					api.http_method, Method_EasySelect('filelist_power_check', this.control, r)
				).then(res => {
					res = JSON.parse(res);
					let o = {};
					o = res.data.data[0];
					o.msg = res.data.msg;
					this.filelist_control = o;
					// console.log(this.filelist_control);
			
			
				});
			
			
			},
			select_method: function(type, tfile) {
				// console.log('操作=' + type);
				switch (type) {
					case 'new':
						this.data_clear();
						break;
					case 'showblank':
						this.new_blank();
						break;
					case 'add':
						// 不能在方法里传  this.变量
						this.fun_upd('_add');
						break;
					case 'upd':
						this.fun_upd('_upd');
						break;
					case 'del':
						this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.fun_upd('_del');
						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消删除'
							});
						});
						break;
					case 'sel':
						this.load_db_data();
						break;
					case 'sub':
						this.fun_upd('_sub');
						break;
					case 'bad':
						this.fun_upd('_bad');
						break;
					case 'exl_up':
						this.excelup();
						break;
					case 'exl_down':
						this.build_exceldata();
						break;
					case 'filelist':
						let temp_id = 0;
						switch (this.sel_from) {
							case 'm':
								temp_id = this.row_id;
								break;
							case 'd':
								temp_id = this.d_row_id;
								break;
							default:
								break;
						}
						this.fun_file_list(this.sheet_no, temp_id, this.sheet_flag, this.file_url, this.file_src,
							tfile);
					
						break;
					default:
						this.$message.error('错误:标识:' + type + ' 没有配置相应方法!');
						break;
				}
			},
			load_db_data: function() {
				// console.log('全条件查询====');
				// console.log(this.parm_sel);
				let d = [];
				// console.log('查询条件',this.parm_sel);

				for (let i = 0; i < this.parm_sel.length; i++) {
					let t = 0;
					t = i + 1 + '';
					switch (t) {
						case '1':
							this.kw1 = this.parm_sel[i].val;
							break;
						case '2':
							this.kw2 = this.parm_sel[i].val;
							break;
						case '3':
							this.kw3 = this.parm_sel[i].val;
							if (this.parm_sel[i].type == 'datemonth') {
								this.kw3 = dateFormatbyChina(this.kw3);
							}
							break;
						case '4':
							this.kw4 = this.parm_sel[i].val;
							if (this.parm_sel[i].type == 'datemonth') {
								this.kw4 = dateFormatbyChina(this.kw4);
							}
							break;
						case '5':
							this.kw5 = this.parm_sel[i].val;
							break;
						case '6':
							this.kw6 = this.parm_sel[i].val;
							break;
						case '7':
							this.kw7 = this.parm_sel[i].val;
							break;
						case '8':
							this.kw8 = this.parm_sel[i].val;
							break;
						case '9':
							this.kw9 = this.parm_sel[i].val;
							break;
						case '10':
							this.kw10 = this.parm_sel[i].val;
							break;
					}

					d.push(this.parm_sel[i].val)
				}



				let that = this;
				let rr = (Math.random() * 1000000000 + '').substring(0, 8);
				// setTimeout(function() {
				//   that.load_url = api.http_method;

				//   if (that.sel_action_flag == 'more') {
				//     that.load_json = Select_PageLengthMore(that.sel_action, that.nowpage, that.page_length, d, r);
				//   } else {
				//     that.load_json = Select_PageLength(that.sel_action, that.nowpage, that.page_length, that.kw1,
				//       that.kw2, that.kw3, that.kw4, that.kw5, that.kw6, that.kw7, that.kw8, that.kw9, that.kw10, r);
				//   }
				// }, 200);

				this.load_url = api.http_method;
				// console.log('全条件查询=sel_action_flag=' + this.sel_action_flag + ' r=' + rr);

				if (this.sel_action_flag == 'more') {
					this.load_json = Select_PageLengthMore(this.sel_action, this.nowpage, this.page_length, d, rr);
				} else {
					that.load_json = Select_PageLength(that.sel_action, that.nowpage, that.page_length, that.kw1, that
						.kw2, that
						.kw3, that.kw4, that.kw5, that.kw6, that.kw7, that.kw8, that.kw9, that.kw10, rr);
				}


				if (this.isFatherSel == '1') {
					this.$emit('base2-event', 'father', this.parm_sel);
				}

			},
			fun_change_title: function(type, new_title) {
				// console.log(new_title);
				if (type == 'main') {
					this.parm_th = JSON.parse(new_title);
				}
			},
			refresh_data: function(type, page, pagelength, backdata) {
				if (typeof(page) === 'undefined' || Number(page) == 0) {
					page = 1;
				}

				if (typeof(pagelength) === 'undefined' || Number(pagelength) == 0) {
					pagelength = 20;
				}

				console.log('查询刷新=' + type + ' page=' + page + ' pagelength=' + pagelength);
				// console.log(backdata);
				// PAGE_LENGTH_CHANGE 改变分页长度,刷新加载

				this.page_length = pagelength;
				this.nowpage = page;
				this.load_db_data();

				if (type == 'IMAGE_LIST' && backdata.length > 0) {
					this.file_list_main = [];
					this.file_list_main = backdata;
					return;
				}
				// let r = (Math.random() + '').substring(0, 8);

				let back = null;
				if (typeof(backdata) != "undefined" && backdata != '') {
					back = JSON.parse(backdata);
					// console.log(back);
					// console.log('new_id=' + back.new_id);
					this.row_id = back.new_id;
					this.sheet_flag = back.msg;
					// 同步关键参数便于后续修改
					this.sys_date = back.sys_date;
					this.sheet_no = back.sheet_no;
					for (let i = 0; i < this.parm.length; i++) {
						if (this.parm[i].key == 'sheet_no') {
							this.parm[i].val = this.sheet_no;
							break;
						}
					}

					let postjson = '';

					if (this.sel_action_flag == 'more') {
						let d = [];
						d.push('ID' + this.row_id);
						postjson = Select_PageLengthMore(this.sel_action, 1, 1, d, r);
					} else {
						postjson = Select_PageLength(this.sel_action, 1, 1, 'ID' + this.row_id, '', '', '', '', '', '',
							'', '', '', '', '', r);
					}

					this.element_loading = true;
					let r = (Math.random() + '').substring(0, 8);
					this.$post(
						api.http_method, postjson
					).then(res => {
						res = JSON.parse(res);

						this.element_loading = false;

						if (Number.parseInt(res.data.status) == 1) {
							let bd = [];
							let t = res.data.data;
							for (let i = 0; i < t.length; i++) {
								let arr = [];
								for (let j in t[i]) {
									// //console.log('key=' + j);       //输出key
									// //console.log('val=' + t[i][j]); //输出key对应的value
									let o = {};
									o.key = j;
									o.val = t[i][j];
									arr.push(o);
								}
								bd.push(arr);
							}

							this.sel_row(bd[0], 'edit');

							if (typeof(this.d_sel_action) != 'undefined' && this.d_sel_action != '') {
								this.fun_d_load();
							}


						} else {
							this.$message({
								message: '编辑数据更新失败! \r\n ' + res.data.msg,
								type: 'success'
							});
						}


					});

				}

				if (this.sheet_flag.indexOf('提交成功') >= 0) {
					this.show_btn = false;
				} else {
					this.show_btn = true;
				}

				if (this.sheet_flag.indexOf('删除成功') == 0) {
					this.closeshow();
					return;
				}



				//如果弹出编辑界面，有非编辑内容。应该查询一下，进行更新

			},
			excelup: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['excelup'].show_edit();
				});
			},
			new_blank: function() {
				this.show_tan = true;
				this.show_btn = true;
				this.show_btn_ok = false;
				this.d_detail = [];

				this.row_id = '';
				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';

				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'selectnew' || this.parm[j].type == 'select') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
					} else {
						this.parm[j].val = '';
					}

				}

				for (let j = 0; j < this.parm_sel.length; j++) {
					if (this.parm_sel[j].type == 'selectnew' || this.parm_sel[j].type == 'select') {
						this.parm_sel[j].val = '';
						this.parm_sel[j].sel_name = '';
					} else {
						this.parm_sel[j].val = '';
					}

				}

				// --d_parm
				for (let j = 0; j < this.d_parm.length; j++) {
					if (this.d_parm[j].type == 'selectnew' || this.d_parm[j].type == 'select') {
						this.d_parm[j].val = '';
						this.d_parm[j].sel_name = '';
					} else {
						this.d_parm[j].val = '';
					}

				}

				this.show_edit();
			},
			edit_data: function() {
				this.show_tan = true;
				// 双击打开界面,如果有明细,应该查询
				// console.log(this.d_upd_action);
				if (typeof(this.d_upd_action) != 'undefined' && this.d_upd_action != '') {
					this.fun_d_load();
				}
				this.show_edit();
			},
			sel_row: function(item, type) {
				// if (type == 'edit') {
				//   console.log('修改更新', item);
				// }
				this.sel_from = 'm'; //如果使用图片集，切换到主表
				//2、遍历Json串获取其属性
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.row_id = item[i].val;
							break;
						case 'flag':
							this.sheet_flag = item[i].val;
							break;
						case 'sys_date':
							this.sys_date = item[i].val;
							break;
						case 'sheet_no':
							this.sheet_no = item[i].val;
							break;
						case 'f_url':
							let tt = JsonStr(item[i].val);
							tt = tt.substring(tt.lastIndexOf('/') + 1);
							this.file_name = tt;
							this.file_url = item[i].val;
							if (this.file_name != '') {
								this.file_show = true;
							} else {
								this.file_show = false;
							}
							this.file_up = '';
							break;
						case 'f_src':
							this.file_src = item[i].val;
							break;
						default:
							break;
					}
				}

				for (let i = 0; i < item.length; i++) {
					for (let j = 0; j < this.parm.length; j++) {
						if (this.parm[j].key == item[i].key) {
							if (this.parm[j].type == 'select' || this.parm[j].type == 'selectnew' || this.parm[j]
								.type == 'radio') {
								// console.log(this.parm[j]);
								this.parm[j].val = '';
								this.parm[j].sel_name = item[i].val;
							} else {
								this.parm[j].val = item[i].val;
							}

						}
					}
				}
				// console.log(this.parm)

				// 多附件时生效
				if (this.file_list_main.length > 0) {
					this.file_name = '';
					this.file_url = '';
					this.file_src = '';
					for (let i = 0; i < this.file_list_main.length; i++) {
						if (this.file_list_main[i].sheet_id == this.row_id) {
							this.file_name = BackSpecial(this.file_list_main[i].file_name);
							this.file_url = BackSpecial(this.file_list_main[i].file_url);
							this.file_src = BackSpecial(this.file_list_main[i].file_src);
						}
					}

					if (typeof(this.file_name) == 'undefined' || this.file_name == '') {
						this.file_show = false;
					} else {
						this.file_show = true;
					}
				}


				// 给父组件传点的 row_id，
				this.$emit('base2-event', '', this.row_id, item);
				// 切换背景色
				if (type != 'edit') {
					this.$refs.file_table.setCurrentRowJson('m_', item[1].val);
				}



			},
			data_clear: function() {
				// console.log('清除 历史 参数。。。。');

				this.row_id = '';
				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';

				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'selectnew') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
					} else {
						this.parm[j].val = '';
					}

				}

				for (let j = 0; j < this.parm_sel.length; j++) {
					if (typeof(this.parm_sel[j].type) != 'undefined' && this.parm_sel[j].type == 'selectnew') {
						this.parm_sel[j].val = '';
						this.parm_sel[j].sel_name = '';
					} else {
						this.parm_sel[j].val = '';
					}

				}

				this.kw1 = '';
				this.kw2 = '';
				this.kw3 = '';
				this.kw4 = '';
				this.kw5 = '';
				this.kw6 = '';
				this.kw7 = '';
				this.kw8 = '';
				this.kw9 = '';
				this.kw10 = '';

				// console.log('===END============')
			},
			fun_upd: async function(type) {
				// console.log('操作类型=' + type + ' row_id=' + this.row_id);
				// console.log(this.parm);
				if (type == '_upd') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_add') {
					let stop = false;
					let temp_name = '';
					for (let i = 0; i < this.parm.length; i++) {
						// console.log(this.parm[i]);
						if (this.parm[i].p == '1' && this.parm[i].weight == '1' && this.parm[i].val == '') {
							stop = true;
							temp_name = this.parm[i].name;
							break;
						}
					}
					if (stop) {
						this.$message({
							message: temp_name + '不能为空!',
							type: 'warning'
						});
						return;
					}
				}



				// 数据格式检查
				// console.log('检查前', this.parm);
				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					if (this.parm[i].p == '1') {
						let temp = '';
						if (this.parm[i].type == 'time' || this.parm[i].type == 'datetime') {
							temp = dateFormatbyChina(this.parm[i].val);
						} else if (this.parm[i].type == 'selectnew') {
							// console.log(this.parm[i].key + '下拉选项', this.parm[i])
							if (typeof(this.parm[i].val) === 'number' && Number(this.parm[i].val) > 0) {
								temp = this.parm[i].val;
							} else {
								temp = '0';
								for (let j = 0; j < this.parm[i].list.length; j++) {
									if (this.parm[i].list[j].val == this.parm[i].sel_name) {
										temp = this.parm[i].list[j].id;
									}
								}
							}

						} else if (this.parm[i].type == 'select') {
							// console.log(this.parm[i].key + '下拉选项', this.parm[i])
							if (typeof(this.parm[i].val) === 'number' && Number(this.parm[i].val) > 0) {
								temp = this.parm[i].val;
							} else if (typeof(this.parm[i].list) !== 'undefined' && this.parm[i].list.length > 0) {
								temp = '0';
								let tlist = this.parm[i].list;
								for (let j = 0; j < tlist.length; j++) {
									if (tlist[j].val == this.parm[i].sel_name) {
										temp = tlist[j].id;
									}
								}
							} else {
								temp = '0';
								let t_action = this.parm[i].sel_action;
								let res = await this.loadClass(t_action);
								// console.log(res);
								if (res.status == '1') {
									let tlist = res.data;
									for (let j = 0; j < tlist.length; j++) {
										if (tlist[j].val == this.parm[i].sel_name) {
											temp = tlist[j].id;
										}
									}
								}

							}

						} else {
							temp = this.parm[i].val;
						}

						this.parm[i].val = temp;
					}
				}
				// console.log('检索后', this.parm);


				if (this.edit_flag == 'base_') {
					this.fun_edit_base(type);
				} else {
					this.fun_edit_other(type);
				}


			},
			fun_edit_base: function(type) {
				// console.log('通用编辑方法 ID=' + this.row_id + ' sys_date=' + this.sys_date);
				let d = '';
				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					if (this.parm[i].p == '1') {
						// add 2022-02-15 必须强制删除所有特殊符号，特别是^
						let temp_val = '',
							temp_key = '',
							temp_type = '';
						temp_key = this.parm[i].key;
						temp_val = this.parm[i].val;

						d = d + temp_key + '=' + Word_Right_Delete(temp_val) + '^';
					}
				}
				console.log(d);
				d = d.slice(0, -1);

				let r = (Math.random() + '').substring(0, 8);

				this.upd_json = Method_TableAll(this.upd_action + type, this.check_key, this.row_id, this.sys_date, d,
					r);
			},
			fun_edit_other: function(type) {
				// console.log('自定义编辑方法');
				let d = [];
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].p == '1') {
						d.push(this.parm[i].val);
					}
				}

				let r = (Math.random() + '').substring(0, 8);
				switch (this.edit_flag) {
					case 'exp15':
						this.upd_json = Method_Common('data_' + this.upd_action + type, this.row_id, this.sys_date, d,
							r);
						break;
					case 'exp30':
						this.upd_json = Method_CommonLong('data_' + this.upd_action + type, this.row_id, this.sys_date,
							d, r);
						break;
					case 'exp50':
						this.upd_json = Method_CommonLongLong('data_' + this.upd_action + type, this.row_id, this
							.sys_date, d, r);
						break;
				}
			},
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// console.log('明细数据显示坐标 ' + x + ' ' + y);
				// console.log(that);
				x = that.pageX + 10;
				y = that.pageY;

				var screenWidth = $(window).width();
				var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
				// var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度

				// console.log('页面宽度=' + screenWidth + '页面高度=' + screenHeight);
				// console.log('明细数据显示坐标 ' + x + ' ' + y);

				if ((x + 140) > screenWidth) {
					x = x - 160;
				}

				temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText = temp_css;
				}
				if (type == "1" && item != '') {
					temp_css += "max-width: 500px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";

					let temp_innerHtml = '';
					temp_innerHtml = BackSpecial(item);
					temp_innerHtml = temp_innerHtml.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>")

					document.getElementById("pre_msg_data").innerHTML = temp_innerHtml;
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// console.log('不显示明细');
				document.getElementById("pre_detail_data").style.display = 'none';
				document.getElementById("pre_msg_data").style.display = 'none';
			},
			/****明细部分操作 start***********************************************/
			check_d_parm: function() {
				// console.log('sheet_no=' + this.sheet_no);
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].key == 'sheet_no') {
						this.sheet_no = this.parm[i].val;
						break;
					}
				}
				for (let i = 0; i < this.d_parm.length; i++) {
					if (this.d_parm[i].key == 'sheet_no' && this.d_parm[i].val == '') {
						this.d_parm[i].val = this.sheet_no;
						break;
					}
				}
				//	针对 没有单号 的明细 补充,默认 m_id 为主单ID add 2021-03-26
				// if (nosheet_no) {
				//   for (let i = 0; i < this.d_parm.length; i++) {
				//     if (this.d_parm[i].key == 'm_id') {
				//       this.d_parm[i].val = this.row_id;
				//       break;
				//     }
				//   }
				// }

				let that = this;
				return new Promise((resolve, reject) => {
					let flag = false;
					for (let i = 0; i < that.d_parm.length; i++) {
						if (that.d_parm[i].weight == '1' && that.d_parm[i].val == '') {
							that.$message({
								message: that.title + '明细: ' + that.d_parm[i].name + '为必填项,不能为空!',
								type: 'warning'
							});
							flag = true;
							break;
						}
					}
					resolve(flag)
				})
			},
			d_data_clear: function() {
				this.d_row_id = '';
				this.d_sys_date = ''; //备份点击项目
				// 文件名称、路径、储存 选择确定
				// this.sheet_flag='';
				// this.sheet_no='';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';
				this.file_up = '';

				for (let j = 0; j < this.d_parm.length; j++) {
					if (this.d_parm[j].type != 'selectnew') {
						this.d_parm[j].val = '';
					} else {
						this.d_parm[j].val = '';
						this.d_parm[j].sel_name = '';
						this.d_parm[j].sel_val = {};
					}
				}
			},
			fun_d_upd: function(item) {
				// console.log('编辑');
				// console.log(item);
				this.sel_from = 'd'; //如果使用图片集，切换到明细
				
				this.d_data_clear();

				let p_io = '',
					p_name = '';
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.d_row_id = item[i].val;
							break;
						case 'sys_date':
							this.d_sys_date = item[i].val;
							break;
						case 'f_url':
							let tt = BackSpecial(item[i].val);
							tt = tt.substring(tt.lastIndexOf('/') + 1);
							this.file_name = tt;
							this.file_url = item[i].val;
							if (this.file_name != '') {
								this.file_show = true;
							} else {
								this.file_show = false;
							}
							break;
						case 'f_src':
							this.file_src = item[i].val;
							break;
						case 'p_flag':
							p_io = item[i].val;
							break;
						case 'p_name':
							p_name = item[i].val;
							break;
						default:
							// for (let j = 0; j < this.d_parm.length; j++) {
							// 	if (this.d_parm[j].type == 'radio' && this.d_parm[j].key == item[i].key) {
							// 		if (item[i].val == '是') {
							// 			this.radio = '1';
							// 		} else {
							// 			this.radio = '0';
							// 		}
							// 		// console.log(this.radio);
							// 		this.d_parm[j].val = this.radio;
							// 	} else if (this.d_parm[j].type == 'select' && this.d_parm[j].key == item[i].key) {

							// 		for (let m = 0; m < this.d_parm[j].list.length; m++) {
							// 			if (this.d_parm[j].list[m].val == item[i].val) {
							// 				this.d_parm[j].val = this.d_parm[j].list[m].id;
							// 				break;
							// 			}
							// 		}
							// 		this.d_parm[j].sel_name = item[i].val;

							// 	} else if (this.d_parm[j].type == 'switch' && this.d_parm[j].key == item[i].key) {

							// 		// console.log('编辑元素',item[i])
							// 		// // 写死了  支出 或者 收入
							// 		// this.d_parm[j].sel_name = item[i].val;
							// 		// // 自检
							// 		// for (let k = 0; k < item.length; k++) {
							// 		//   if (item[k].val == '支出') {
							// 		//     console.log(this.d_parm[j].list_out);
							// 		//     for (let m = 0; m < this.d_parm[j].list_out.length; m++) {
							// 		//       if (this.d_parm[j].list_out[m].val == item[i].val) {
							// 		//         this.d_parm[j].val = this.d_parm[j].list_out[m].id;
							// 		//         this.d_parm[j].io = 'o';
							// 		//         break;
							// 		//       }
							// 		//     }
							// 		//   }

							// 		//   if (item[k].val == '收入') {
							// 		//     console.log(this.d_parm[j].list_in);
							// 		//     for (let m = 0; m < this.d_parm[j].list_in.length; m++) {
							// 		//       if (this.d_parm[j].list_in[m].val == item[i].val) {
							// 		//         this.d_parm[j].val = this.d_parm[j].list_in[m].id;
							// 		//         this.d_parm[j].io = 'i';
							// 		//         break;
							// 		//       }
							// 		//     }
							// 		//   }
							// 		// }
							// 		// console.log('二级切换', this.d_parm[j]);
							// 	} else {
							// 		if (this.d_parm[j].key == item[i].key) {
							// 			this.d_parm[j].val = item[i].val;
							// 			break;
							// 		}
							// 	}
							// }
							break;
					}
				}

				for (let i = 0; i < item.length; i++) {
					for (let j = 0; j < this.d_parm.length; j++) {
						if (this.d_parm[j].key == item[i].key) {
							if (this.d_parm[j].type == 'select' || this.d_parm[j].type == 'radio' || this.d_parm[j]
								.type == 'selectnew') {
								this.d_parm[j].val = '';
								this.d_parm[j].sel_name = item[i].val;
							} else {
								this.d_parm[j].val = item[i].val;
							}
						}
					}
				}

				//switch 需要单独判断
				// console.log('单独检查 p_io=' + p_io + ' 费用名称=' + p_name);
				for (let j = 0; j < this.d_parm.length; j++) {
					if (this.d_parm[j].type == 'switch') {
						// 写死了  支出 或者 收入
						this.d_parm[j].sel_name = p_name;
						// 自检
						if (p_io == '支出') {
							console.log(this.d_parm[j].list_out);
							for (let m = 0; m < this.d_parm[j].list_out.length; m++) {
								if (this.d_parm[j].list_out[m].val == p_name) {
									this.d_parm[j].val = this.d_parm[j].list_out[m].id;
									this.d_parm[j].io = 'o';
									break;
								}
							}
						}

						if (p_io == '收入') {
							console.log(this.d_parm[j].list_out);
							for (let m = 0; m < this.d_parm[j].list_in.length; m++) {
								if (this.d_parm[j].list_in[m].val == p_name) {
									this.d_parm[j].val = this.d_parm[j].list_in[m].id;
									this.d_parm[j].io = 'i';
									break;
								}
							}
						}

						break;
					}

				}
				// console.log('检索完成', this.d_parm);



				// this.setActiveRowBackColor('d', item[0].val, 'detail');

			},
			fun_d_edit: function(type, item) {
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.d_row_id = item[i].val;
							break;
						case 'sys_date':
							this.d_sys_date = item[i].val;
							break;
						default:
							break;
					}
				}
				this.fun_d_save(type);
			},
			fun_d_del: function(type, item) {
				let flag = true;
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.d_row_id = item[i].val;
							break;
						case 'f_url':
							if (item[i].val != '') {
								flag = false;
							}
							break;
						default:
							break;
					}
				}
				if (flag) {
					this.fun_d_save(type);
				} else {
					this.$message({
						message: '请先删除附件,再删除数据!',
						type: 'warning'
					});
				}
			},
			fun_d_load: function() {
				// 加载明细数据
				// console.log('加载明细数据=' + this.sheet_no);
				// console.log(this.parm);
				if (this.d_sel_action == '') {
					return;
				}

				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].key == 'sheet_no') {
						this.sheet_no = this.parm[i].val;
						break;
					}
				}
				// console.log('sheet_no=' + this.sheet_no);
				let nosheet_no = true;
				for (let i = 0; i < this.d_parm.length; i++) {
					if (this.d_parm[i].key == 'sheet_no') {
						this.d_parm[i].val = this.sheet_no;
						nosheet_no = false;
						break;
					}
				}

				//	针对 没有单号 的明细 补充,默认 m_id 为主单ID add 2021-03-26
				if (nosheet_no) {
					for (let i = 0; i < this.d_parm.length; i++) {
						if (this.d_parm[i].key == 'm_id') {
							this.d_parm[i].val = this.row_id;
							this.sheet_no = this.row_id; //sheet_no 和  row_id 混和，不好这样，下次涉及注意优化
							break;
						}
					}
				}

				this.d_detail = [];

				if (this.sheet_no == null || this.sheet_no == '') {
					this.$message({
						message: '明细数据单号未匹配到,请刷新重试或联系开发人员!',
						type: 'warning'
					});
				}

				this.element_loading = true;
				this.$post(
					api.http_method,
					Method_EasySelect('data_' + this.d_sel_action, this.sheet_no)
				).then(res => {
					this.element_loading = false;
					try {
						res = JSON.parse(res);
						if (Number.parseInt(res.data.status) == 1) {
							this.maxpage = res.data.allpage;
							if (Number(res.data.allpage) == 0) {
								this.$message({
									message: '没有查询到数据',
									type: 'success'
								});
							} else {
								// console.log(res.data.data);
								// this.data_tab = res.data.data;
								let t = res.data.data;
								for (let i = 0; i < t.length; i++) {
									let arr = [];
									for (let j in t[i]) {
										// console.log('key=' + j);       //输出key
										// console.log('val=' + t[i][j]); //输出key对应的value
										let o = {};
										o.key = j;
										o.val = t[i][j];
										arr.push(o);
									}
									this.d_detail.push(arr);
								}

								this.refresh_data();

								// 更新点击项目
								// console.log('更新点击项目 d_row_id='+this.d_row_id);
								for (let i = 0; i < this.d_detail.length; i++) {
									// console.log(this.d_detail[i]);
									for (let j = 0; j < this.d_detail[i].length; j++) {
										// console.log('key='+this.d_detail[i][j].key+'  val='+this.d_detail[i][j].val);
										if (this.d_detail[i][j].key == 'id' && this.d_detail[i][j].val == this
											.d_row_id) {
											this.fun_d_upd(this.d_detail[i]);
											break;
										}
									}

								}
							}
						} else {
							this.$message({
								message: '明细 ' + res.data.msg,
								type: 'success'
							});
						}
					} catch (ex) {
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				});


			},
			fun_d_save: async function(type) {
				if (type == '_del') {
					if (this.d_row_id == 0) {
						this.$message({
							message: '请选择要删除的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_add' || type == '_upd') {

					for (let i = 0; i < this.d_parm.length; i++) {
						if (this.d_parm[i].p == '1') {
							let temp = '';
							if (this.d_parm[i].type == 'time' || this.d_parm[i].type == 'datetime') {
								temp = dateFormatbyChina(this.d_parm[i].val);
							} else if (this.d_parm[i].type == 'selectnew') {
								//console.log(this.d_parm[i].key + '下拉选项', this.d_parm[i])
								if (typeof(this.d_parm[i].val) === 'number' && Number(this.d_parm[i].val) > 0) {
									temp = this.d_parm[i].val;
								} else {
									temp = '0';
									for (let j = 0; j < this.d_parm[i].list.length; j++) {
										if (this.d_parm[i].list[j].val == this.d_parm[i].sel_name) {
											temp = this.d_parm[i].list[j].id;
										}
									}
								}

							} else if (this.d_parm[i].type == 'select') {
								// //console.log(this.d_parm[i].key + '下拉选项', this.d_parm[i])
								if (typeof(this.d_parm[i].val) === 'number' && Number(this.d_parm[i].val) > 0) {
									temp = this.d_parm[i].val;
								} else if (typeof(this.d_parm[i].list) !== 'undefined' && this.d_parm[i].list.length >
									0) {
									temp = '0';
									let tlist = this.d_parm[i].list;
									// console.log('简单配置',tlist)
									for (let j = 0; j < tlist.length; j++) {
										// console.log(tlist[j].val+' ='+this.d_parm[i].sel_name)
										if (tlist[j].val === this.d_parm[i].sel_name) {
											temp = tlist[j].id;
											break;
										}
									}
								} else {
									temp = '0';
									let t_action = this.d_parm[i].sel_action;
									let res = await this.loadClass(t_action);
									// //console.log(res);
									if (res.status == '1') {
										let tlist = res.data;
										for (let j = 0; j < tlist.length; j++) {
											if (tlist[j].val == this.d_parm[i].sel_name) {
												temp = tlist[j].id;
												break;
											}
										}
									}

								}

							} else {
								temp = this.d_parm[i].val;
							}
							// console.log(this.d_parm[i].key+'='+temp);
							this.d_parm[i].val = temp;
						}
					}
					// console.log(this.d_parm);

					let flag = false;
					flag = await this.check_d_parm();
					if (flag) {
						return;
					}

				}

				if (type == '_upd' || type == '_sub' || type == '_bad') {
					if (this.d_row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}



				let d = [];
				for (let i = 0; i < this.d_parm.length; i++) {

					if (this.d_parm[i].p == '1') {
						if (this.d_parm[i].type == 'time' || this.d_parm[i].type == 'datetime') {
							d.push(dateFormatbyChina(this.d_parm[i].val));
						} else {

							d.push(this.d_parm[i].val);
						}
					}
				}
				// console.log('d_row_id=' + this.d_row_id);
				let temp_data = '';
				temp_data = Method_Common('data_' + this.d_upd_action + type, this.d_row_id, this.d_sys_date, d);

				this.element_loading = true;
				this.$post(
					api.http_method, temp_data
				).then(res => {
					try {
						res = JSON.parse(res);
						// console.log(res);
						if (res.data.status == 1) {
							this.$message({
								message: res.data.msg,
								type: 'success'
							});

							// document.getElementById('isfirst').focus();
							let that = this;
							setTimeout(function() {
								that.fun_d_load();
							}, 500)

						} else {
							this.$message.error(res.data.msg);
						}
						this.element_loading = false;

					} catch (ex) {
						this.element_loading = false;
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				})

			},
			/****明细部分操作 end***********************************************/
			build_exceldata: function(type) {
				// 不做分页
				if (type == 'close') {
					this.show_excel = false;
				} else {
					let d = [];

					for (let i = 0; i < this.parm_sel.length; i++) {
						switch (this.parm_sel[i].sel) {
							case '1':
								this.kw1 = this.parm_sel[i].val;

								break;
							case '2':
								this.kw2 = this.parm_sel[i].val;
								break;
							case '3':
								this.kw3 = this.parm_sel[i].val;
								if (this.parm_sel[i].type == 'datemonth') {
									this.kw3 = dateFormatbyChina(this.kw3);
								}
								break;
							case '4':
								this.kw4 = this.parm_sel[i].val;
								if (this.parm_sel[i].type == 'datemonth') {
									this.kw4 = dateFormatbyChina(this.kw4);
								}
								break;
							case '5':
								this.kw5 = this.parm_sel[i].val;
								break;
							case '6':
								this.kw6 = this.parm_sel[i].val;
								break;
							case '7':
								this.kw7 = this.parm_sel[i].val;
								break;
							case '8':
								this.kw8 = this.parm_sel[i].val;
								break;
							case '9':
								this.kw9 = this.parm_sel[i].val;
								break;
							case '10':
								this.kw10 = this.parm_sel[i].val;
								break;
						}

						d.push(this.parm_sel[i].val);
					}

					let postjson = '';
					if (this.sel_action_flag == 'more') {
						postjson = Select_PageLengthMore(this.sel_action, this.nowpage, this.page_length, d);
					} else {
						postjson = Select_PageLength(this.sel_action, this.nowpage, this.page_length, this.kw1, this
							.kw2,
							this.kw3, this.kw4, this.kw5, this.kw6, this.kw7, this.kw8, this.kw9, this.kw10);
					}

					this.postjson1 = Object.assign({}, this.postjson1, {
						type: 'down1',
						url: api.http_method,
						post: postjson
					});

					this.show_excel = true;
				}
			},
			setActiveRowBackColor: function(key, id, type) {
				// console.log('key=' + key + ' id=' + id + ' type=' + type);
				key = key + '_';
				switch (type) {
					case 'detail':
						for (var i = 0; i < this.d_detail.length; i++) {
							// console.log(this.d_detail[i]);
							if (this.d_detail[i][0].val == id) {
								document.getElementById(key + id).style.background = '#92a4f3';
							} else {
								if (this.d_detail[i][0].val % 2 == 0) {
									document.getElementById(key + this.d_detail[i][0].val).style.background = '#fff';
								} else {
									document.getElementById(key + this.d_detail[i][0].val).style.background =
										'#f5f5f5';
								}
							}
						}
						break;
					case 'main':
						break;
				}
			}
			
		}
	};
</script>


<style scoped>
	.pretop {
		margin-top: 5px;
	}

	.pre_tab {
		width: auto;
		overflow-x: auto;
		white-space: nowrap;
		/* max-width: 1280px; */
	}

	.pre_table_detail_new {
		margin-top: 3px;
		/* table-layout:fixed; 这样做可以使半角连续字符强制换行，不至于撑破列宽。
    需要注意的是，使用此参数后，不要轻易在tr(行)或td(列)
    中加入height属性，会使table不再被内容撑出适合的高度 */
		table-layout: fixed;
		word-break: break-all;
		word-wrap: break-word;
		border-collapse: collapse;
		margin: 0;
		padding: 0;

	}

	.pre_table_detail_new td {
		/* padding: 2px 6px 2px 6px; */
		vertical-align: middle;
		box-sizing: border-box;
		min-width: 1px;
		/* width: auto; */
		max-width: 480px;
		font-size: 14px;
		text-align: center;
		height: 24px;
		line-height: 22px;
		/* border: 1px solid #3f3f3f; */
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: keep-all;
		/* 避免长单词截断，保持全部 */

		/* 换行 */
		/* white-space: pre-line;
    word-wrap: break-word;
    word-break: break-all; */
	}

	.tab_header_new td {
		/* 纵向渐变 */
		/* Safari 5.1 - 6.0 */
		background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
		/* Opera 11.1 - 12.0 */
		background: -o-linear-gradient(#3da5d9, #a2d2ff);
		/* Firefox 3.6 - 15 */
		background: -moz-linear-gradient(#3da5d9, #a2d2ff);
		/* 标准的语法（必须放在最后） */
		background: linear-gradient(#3da5d9, #a2d2ff);
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: 500;
	}

	/* 首列是ID,不排序,隐藏 */
	.pre_table_detail_new tr td:nth-child(1) {
		display: none;
	}

	.pre_table_detail_new tr td:nth-child(2) {
		min-width: 48px;
		width: 48px;
		max-width: 48px;
	}

	.pre_table_detail_new tr td:nth-last-child(1) {
		min-width: 168px;
		width: 168px;
	}

	.tab_tr_all>td {
		vertical-align: baseline;
		padding: 2px 5px 2px 5px;
		background-color: rgb(134, 202, 219);
		border: 1px solid #3f3f3f;
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: bolder;
		height: 25px;
		line-height: 25px;
	}

	/* 表格内按钮 */
	.pre_table_detail_new td button {
		border: 1px solid #aaa;
		text-align: center;
		display: inline-block;
		margin-left: 2px;
		margin-right: 2px;
		cursor: pointer;
		border-radius: 5px;
		padding-left: 5px;
		padding-right: 5px;
	}

	/* 表格内输入框 */
	.pre_table_detail_new td input {
		width: 100%;
		height: 100%;
		border: 0px;
		text-align: left;
		padding: 2px 2px 2px 2px;
		/* font-size: 16px; */
	}

	.pre_table_detail_new td span {
		width: 24px;
		height: 24px;
		border: 0px;
		text-align: left;
		background-color: #cfcfcf;
		padding: 2px 2px 2px 2px;
		font-size: 14px;
		margin-left: 5px;
		margin-right: 5px;
		border-radius: 5px;
	}

	.pre_table_detail_new td span:hover {
		cursor: pointer;
		background: #aaa;
		/* font-size: 16px; */
	}

	.pre_table_detail_new tr:nth-child(odd) {
		background-color: #f5f5f5;
	}

	.pre_table_detail_new tr:nth-child(even) {
		background-color: #fff;
	}

	.pre_table_detail_new tr:hover {
		background-color: #b8f8b8 !important;
	}

	/*  .pre_table_detail_new tr:focus {
    background: #92a4f3 !important;
  } */
	/* 取消a标签的默认样式 */
	a {
		/* display: block; */
		height: 100%;
		text-decoration: none;
		color: #333;
	}

	.pre_table_detail_new tr>td>a:focus {
		background: #92a4f3 !important;
	}


	/* 翻页样式 */
	.pre_page {
		width: 100%;
		margin-top: 5px;
		/* padding-bottom: 5px; */
	}

	.pre_page>ul {
		text-align: right;
		list-style: none;
	}

	.pre_page>ul>li>label {
		width: 24px;
		min-width: 24px;
	}

	.pre_page>ul>li>input {
		width: 48px;
		min-width: 48px;
	}

	.pre_page>ul>li>a {
		text-decoration: none;
	}

	.pre_page>ul>li>.go {
		display: inline-block;
		width: 30px;
		height: 20px;
		border: 1px solid #cccccc;
		background: #024aee;
		color: #fff;
		border-radius: 4px;
		text-align: center;
		margin-left: 5px;
	}

	.pre_page>ul>li>a:hover {
		color: #394656;
	}


	.pre_tan_conten {
		position: fixed;
		width: 80%;
		height: auto;
		left: 10%;
		top: 8%;
		/* background: #faf5f5; */
		/* background-color: azure; */
		border-radius: 5px;
		max-height: 80%;
		z-index: 3;
		overflow-y: auto;
		overflow-x: hidden;

	}



	/* 设置 倒数 第二、第三列 隐藏 */
	.last-two-none>td:nth-last-child(3),
	.last-two-none>td:nth-last-child(2) {
		display: none;
	}

	.last-two-none>td:nth-last-child(2) {
		display: none;
	}


	.trans_edit {
		/* min-width: 1600px; */
		max-height: 80%;
		overflow-y: auto;
	}

	.tab-item {
		/* margin: 0px; */

		/* margin-top: 2px; */
		/* min-width: 256px; */
		margin-right: 10px;
		padding-top: 2px;
		padding-bottom: 2px;
		/*  border-bottom: 1px solid #0000ff;  */
		/* border-left: 1px solid #0000ff; */
		/* border-right: 1px solid #0000ff; */
	}



	.col-item {
		display: inline-block;
		min-width: 254px;
		width: 254px;
		max-width: 254px;
		vertical-align: top;
	}

	.col-top {
		margin-top: 37px;
	}

	.col-item .content_edit_item input {
		text-align: left;
	}


	.pre_leve_one {
		margin: 0px;
	}

	.content_edit_item label {
		display: inline-block;
		min-width: 96px;
	}


	.tab-row {
		display: block;
		overflow: auto;
	}
</style>


<!--

名称：通用基础模板3.0
日期：2022-03-06
作者：hj
目标：
方法 传入参数，
1、主界面固定按钮:查询、新建、备注说明,权限控制 导入和导出
2、弹窗编辑界面:通过权限控制 查询、增加、删除、修改、提交、导入、导出。、文件操作。
3、通过Json变量 parm_sel和动态组件 自动生成查询 区域
3、通过Json变量 parm    和动态组件 自动生成编辑 区域
3、通过sel标识+动态组件 构建查询 区域
4、通过 弹窗形式编辑

5、主单据功能: 分页查询+通用编辑+table 可以换行
    明细功能: 单页查询+通用编辑方法+文件  待测试

            {
              "name": "申请单",
              "val": "",
              "key": "val",
              "type": "text",
              "class": "long2",
              "sel_action":"data_alluser",  当需要从一列数据选择时，传入查询关键字
              "sel": "1"， 是否查询字段
              "p": "1",    是否传参自动
              "w": "1",    是否必填
              "x": "2"     布局行数
              "r": "1"     是否只读
            }


        -->